import React from 'react';
import {
    Col,
    Card,
    Menu,
    Dropdown,
    Tooltip
  } from 'antd';
import { Link } from 'react-router-dom'
import { ReactComponent as MoreIcon } from '../../../../icons/more.svg'
import * as Utilities from '../../Utilities'
import ENVIRONMENT from '../../../../environments';

const requestCardLabels = {
    incomplete: "Incomplete Submission",
    awaiting: "In Progress"
};


let get_options = (onDelete, id, type) => {
    return <Menu>
    <Menu.Item>
      <a onClick={() => onDelete(id, type) }>Delete Request</a>  
    </Menu.Item>
    
  </Menu>
  };

const ReviewCardsLinkList = (props) => {
    let itemList = []
    let searchedItems = []
    
    if (props.searchValue == '') {
        searchedItems = props.products
    }
    else {
        searchedItems = Utilities.getRelevanceBasedOrderedSearchResult(props.searchValue, props.products)
    }
    searchedItems.map((ele, index)=> {
        let entityEntry = null;
        if(ele.type == 'Product' ||
            ele.type == 'Product Silo Images' ||
            ele.type == 'Product Dimensional Image' ||
            ele.type == 'Product Video' ||
            ele.type == 'Product 360 Spin'){
            entityEntry =  <ProductItemLink ele={ele} key={index} showDeletedModelOption={props.showDeletedModelOption} setDeleteModal={props.setDeleteModal} openMaterialModal={props.openMaterialModal} />
        }
        if(ele.type == 'Room'){
            entityEntry = <RoomItemLink ele={ele} key={index} showDeletedModelOption={props.showDeletedModelOption} setDeleteModal={props.setDeleteModal} openMaterialModal={props.openMaterialModal} />
        }
        if(ele.type == 'Scene' || ele.type == 'Scene Renders'){
            entityEntry = <SceneItemLink ele={ele} key={index} showDeletedModelOption={props.showDeletedModelOption} setDeleteModal={props.setDeleteModal} openMaterialModal={props.openMaterialModal} />
        }
        if(ele.type == 'Material'){
            entityEntry = <MaterialItemLink ele={ele} key={index} showDeletedModelOption={props.showDeletedModelOption} setDeleteModal={props.setDeleteModal} openMaterialModal={props.openMaterialModal}/>
        }
        if (entityEntry != null) {
            itemList.push(entityEntry)
        }
    })
    // set the searched count
    if(props.searchValue != ''){
        if(props.state == 'awaiting')
            props.setSearchedInproressCount(itemList.length)
        else if(props.state == 'incomplete')
            props.setSearchedIncompleteCount(itemList.length)
    }

    if(!props.expanded)
        itemList = itemList.slice(0, 4);
    console.log('item list = ', itemList)
    return (<>{itemList}</>)
}

const ProductItemLink = (props) => {
    const { ele } = props;
    let url = '';
    if (ele.thumbnail) {
        if (Array.isArray( ele.thumbnail ) && ele.thumbnail.length == 0) {
            url = '';
        } else {
            url = ENVIRONMENT.getBaseURL(ele.platform) + ENVIRONMENT.THUMBNAIL_URI + ele.thumbnail;
        }
    }

    console.log(ele.thumbnail)
    return (
        <Col lg={6} sm={24} md={8} key={props.key} offset={0}>
            <Card id="#entity-container" className="card-shadow-product" bordered={false} style={{ marginRight: "20px", marginBottom: "20px" }}>
                <div className="suggested-product" >
                    {props.showDeletedModelOption ? <Dropdown className="group-settings more-icon" overlay={get_options(props.setDeleteModal, ele.id, 'Product')} trigger={['click']}>
                        <MoreIcon/>
                    </Dropdown> : ""}
                    <Link to={(ele.state == "incomplete") ?ele.uploaded_model && ele.model_status == -6 ? "/inprogress-product/" + ele.id :  ele.uploaded_model ? "/upload-product-model/" + ele.id + '?uploaded-model=true' : ele.designed_product ? "/add-new-product/" + ele.id : "/create-existing-physical-product/" + ele.id : "/product_page/" + ele.id}>
                    <div className="box">
                        {url != '' ? 
                        <img style={{objectFit: "contain",height:"280px",opacity:"0.5",filter:"blur(0px)"}} className="product-image" src={url} />
                        :
                        <img style={{objectFit: "contain",height:"280px",opacity:"0.5",filter:"blur(0px)"}} className="product-image" src={require("../../../../assets/images/product_incomplete.svg")} />
                        }


                        <div className="home-entity-label justify-in-start" style={{float: 'right'}}>
                            <span className="entity-label-bg manrope f-12 w-700 blue">
                            {ele.type}
                            </span>
                        </div>
                     
                        <div className="incomplete-submission-text manrope f-12 w-700 red-d9">
                            {requestCardLabels[ele.state]}
                        </div>
                        {/* <div className="incomplete-request-text  manrope f-14 grey-73">
                            { ele.state === "awaiting" ? <span>Click to View In Progress {ele.type}</span> : <span>Click to complete your request</span>}
                        </div> */}
                    </div>
                   

                    <div className='justify-in-start' style={{marginTop:"12px","text-align":"left", marginLeft:"12px"}}>
                        <Tooltip title={<span className='manrope f-12 white'>{ele.name}</span>}>
                            <span className="manrope f-14 black-14 w-500 clamp-text w-50">{ele.name}</span>
                        </Tooltip>
                        <Tooltip title={<span className='manrope f-12 white'>{Utilities.timestampToTimeSince(ele.last_modified, 'tooltip')}</span>}>                                                  
                            <span className="manrope f-12 grey-77 w-500 time-clock-bg"  style={{marginLeft: 4}}>
                                <img src='/img/carbon_time.svg'  style={{marginRight: 2}}/>{Utilities.timestampToTimeSince(ele.last_modified)}
                            </span>
                        </Tooltip>
                    </div>

                    
                    <div className="manrope f-12 grey-77 capitalize justify-in-start" style= {{marginBottom:12, marginTop: 8,textAlign:"left", marginRight: 12,marginLeft: 12}}> 
                        <span  style={{marginRight: 4}}>Category: </span>
                        <span style={{"color":"#333333"}}>{ele.category || 'N/A'}</span>
                    </div>
                   
                   
                    </Link>
                </div>
            </Card>
        </Col>
    )
}

const MaterialItemLink = (props) => {
    const { ele } = props;
    let parsed_text = '';
    let url = '';
    if (ele.material_files && ele.material_files.length > 0) {
        parsed_text = JSON.parse(ele.material_files);
        if (parsed_text && parsed_text[0]) {
            url =  ENVIRONMENT.getBaseURL(ele.platform) + ENVIRONMENT.BASE_URI +  encodeURIComponent(parsed_text[0].uid + '/' + parsed_text[0].name);
        }
    }   
    
    return (
        <Col lg={6} sm={24} md={8} key={props.key} offset={0}>
            <Card id="#entity-container" className="card-shadow-product" bordered={false} style={{ marginRight: "20px", marginBottom: "20px",cursor:"pointer" }}>
                <div className="suggested-product" >
                    {props.showDeletedModelOption ? 
                        <Dropdown className="group-settings more-icon" overlay={get_options(props.setDeleteModal, ele.id, 'Material')} trigger={['click']}>
                            <MoreIcon/>
                        </Dropdown> : ""}
                    <div className="box" onClick={() => props.openMaterialModal(ele)}>
                        {url && !ele.is_scanned ?
                        <img className="dashboard-img material product-image" src={url} />
                        :
                        <img  className="dashboard-img product-image" src={require("../../../../assets/images/material_incomplete.svg")} />}

                        <div className="home-entity-label justify-in-start" style={{float: 'right'}}>
                            <span className="entity-label-bg manrope f-12 w-700 blue">
                                {ele.type}
                            </span>
                        </div>
                        <div  className="incomplete-submission-text manrope f-12 w-700 red-d9">
                            {requestCardLabels[ele.state]}
                        </div>
                        {/* <div className="incomplete-request-text  manrope f-14 grey-73">
                            { ele.state === "awaiting" ? <span>Click to View In Progress {ele.type}</span> : <span>Click to complete your request</span>}
                        </div> */}
                    </div>
                  
                    <div className='justify-in-start' style={{marginTop:"12px","text-align":"left", marginLeft:"12px"}}>
                        <Tooltip title={<span className='manrope f-12 white'>{ele.name}</span>}>
                            <span className="manrope f-14 black-14 w-500 clamp-text w-50">{ele.name}</span>
                        </Tooltip>
                        <Tooltip title={<span className='manrope f-12 white'>{Utilities.timestampToTimeSince(ele.last_modified, 'tooltip')}</span>}>                                                  
                            <span className="manrope f-12 grey-77 w-500 time-clock-bg"  style={{marginLeft: 4}}>
                                <img src='/img/carbon_time.svg'  style={{marginRight: 2}}/>{Utilities.timestampToTimeSince(ele.last_modified)}
                            </span>
                        </Tooltip>
                    </div>
                    {ele.category ? <div className="manrope f-12 grey-77 capitalize justify-in-start" style= {{marginBottom:12, marginTop: 8,textAlign:"left", marginRight: 12,marginLeft: 12}}> 
                        <span  style={{marginRight: 4}}>Category: </span>
                        <span style={{"color":"#333333"}}>{ele.category || 'N/A'}</span>
                    </div>: ''}
                  
                   
                </div>
            </Card>
        </Col>
    )
}

const RoomItemLink = (props) => {
    const { ele } = props;
    let url = '';
    if (ele.thumbnail) {
        if (Array.isArray( ele.thumbnail ) && ele.thumbnail.length == 0) {
            url = '';
        } else {
            url = ENVIRONMENT.getBaseURL(ele.platform) + ENVIRONMENT.SPACE_THUMBNAIL_URI + ele.thumbnail;
        }
    }
    return (
        <Col lg={6} sm={24} md={8} key={props.key} offset={0}>
            
            <Card id="#entity-container" className="card-shadow-product" bordered={false} style={{ marginRight: "20px", marginBottom: "20px" }}>
                <div className="suggested-product" >
                    {props.showDeletedModelOption ? <Dropdown className="group-settings more-icon" overlay={get_options(props.setDeleteModal, ele.id, 'Space')} trigger={['click']}>
                        <MoreIcon/>
                    </Dropdown> : ""}
                    <Link to={(ele.state == "incomplete") ?  "/add-new-room?step=0&room_id=" + ele.id : "/rooms/" + ele.id}>
                        <div className="box">
                            {url != '' ? 
                                <img style={{objectFit: "contain",height:"280px",opacity:"0.5",filter:"blur(0px)"}} className="product-image" src={url} />
                                :
                                <img style={{objectFit: "contain",height:"280px",opacity:"0.5",filter:"blur(0px)"}} className="product-image" src={require("../../../../assets/images/space_incomplete.svg")} />
                                }

                            <div className="home-entity-label justify-in-start" style={{float: 'right'}}>
                                <span className="entity-label-bg manrope f-12 w-700 blue">
                                Space
                                </span>
                            </div>
                            <div className="incomplete-submission-text manrope f-12 w-700 red-d9">
                                {requestCardLabels[ele.state]}
                            </div>
                            {/* <div className="incomplete-request-text manrope f-14 grey-73">
                            { ele.state === "awaiting" ? <span>Click to View In Progress Space</span> : <span>Click to complete your request</span>}
                            </div> */}
                        </div>

                        <div className='justify-in-start' style={{marginTop:"12px","text-align":"left", marginLeft:"12px"}}>
                            <Tooltip title={<span className='manrope f-12 white'>{ele.name}</span>}>
                                <span className="manrope f-14 black-14 w-500 clamp-text w-50">{ele.name}</span>
                            </Tooltip>
                            <Tooltip title={<span className='manrope f-12 white'>{Utilities.timestampToTimeSince(ele.last_modified, 'tooltip')}</span>}>                                                  
                                <span className="manrope f-12 grey-77 w-500 time-clock-bg"  style={{marginLeft: 4}}>
                                    <img src='/img/carbon_time.svg'  style={{marginRight: 2}}/>{Utilities.timestampToTimeSince(ele.last_modified)}
                                </span>
                            </Tooltip>
                        </div>
                    
                        <div className="manrope f-12 grey-77 capitalize justify-in-start" style= {{marginBottom:12, marginTop: 8,textAlign:"left", marginRight: 12,marginLeft: 12}}> 
                            <span  style={{marginRight: 4}}>Category: </span>
                            <span style={{"color":"#333333"}}>{ele.category || 'N/A'}</span>
                        </div>
                       
                    </Link>
                </div>
            </Card>
        </Col>
    )
}

const SceneItemLink = (props) => {
    const { ele } = props;
    let url = '';
    if(ele.state == 'incomplete' && ele.preview_thumbnail){
        url = ENVIRONMENT.getBaseURL(ele.platform) + ENVIRONMENT.SCENE_PREVIEW_THUMBNAIL_URI + ele['preview_thumbnail']
    }
    else{
        if (ele.scene_thumbnail) {
            if (Array.isArray( ele.scene_thumbnail ) && ele.scene_thumbnail.length == 0) {
                url = '';
            } else {
                if (ele.scene_thumbnail.includes('.jpg') || ele.scene_thumbnail.includes('.png')) {
                    url = ele.scene_thumbnail.replace('thumbnail/', ele.id + '/').replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(ele.platform))
                }
            }
        }
    }
    return (
        <Col lg={6} sm={24} md={8} key={props.key} offset={0}>
            <Card className="card-shadow-product" bordered={false} style={{ marginRight: "20px", marginBottom: "20px" }}>
                <div className="suggested-product" >
                    {props.showDeletedModelOption ? <Dropdown className="group-settings more-icon" overlay={get_options(props.setDeleteModal, ele.id, 'Scene')} trigger={['click']}>
                        <MoreIcon/>
                    </Dropdown> : ""}
                    <a href={"/scene_builder/" + ele.id}>
                        <div className="box">
                            {url != '' ? 
                                <img style={{objectFit: "cover",height:"280px",filter:"blur(2px)"}} className="product-image" src={url} />
                                :
                                <img style={{objectFit: "contain",height:"280px",opacity:"0.5",filter:"blur(0px)"}} className="product-image" src={require("../../../../assets/images/scene_incomplete.svg")} />
                                }

                            <div className="home-entity-label justify-in-start" style={{float: 'right'}}>
                                <span className="entity-label-bg manrope f-12 w-700 blue">
                                {(ele.type == 'Scene')?'Scene Render':ele.type}
                                </span>
                            </div>
                            <div className="thumbnail-btn-bg blur"><span className="thumbnail-btn">{requestCardLabels[ele.state]}</span></div>
                           
                            {/* <div className="incomplete-request-text manrope f-14 grey-73">
                            { ele.state === "awaiting" ? <span>Click to View In Progress Scene 360</span> : <span>Click to complete your request</span>}
                            </div> */}
                        </div>
                      
                        <div className='justify-in-start' style={{margin:"12px",marginBottom: 8,"text-align":"left"}}>
                            <Tooltip title={<span className='manrope f-12 white'>{ele.name}</span>}>
                                <span className="manrope f-14 black-14 w-500 clamp-text w-50">{ele.name}</span>
                            </Tooltip>
                            <Tooltip title={<span className='manrope f-12 white'>{Utilities.timestampToTimeSince(ele.last_modified, 'tooltip')}</span>}>                                                  
                                <span className="manrope f-12 grey-77 w-500 time-clock-bg"  style={{marginLeft: 4}}>
                                    <img src='/img/carbon_time.svg'  style={{marginRight: 2}}/>{Utilities.timestampToTimeSince(ele.last_modified)}
                                </span>
                            </Tooltip>
                        </div>
                        <div className="manrope f-12 grey-77 capitalize justify-in-start" style= {{marginBottom:12, marginTop: 8,textAlign:"left", marginRight: 12,marginLeft: 12}}> 
                            <span  style={{marginRight: 4}}>Category: </span>
                        <span style={{"color":"#333333"}}>{'N/A'}</span>
                    </div>
                   

                    </a>
                </div>
            </Card>
            
        </Col>
    )
}

export default ReviewCardsLinkList;
